import React from "react";
import UserInfo from "../components/UserInfo";
import { useAuth } from "../context/AuthContext";

export default function ProfilUtilisateurModal() {
  const { client, hasRole, isAuthenticated, getToken } = useAuth();


  return (
    // <div
    //   className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-[1050]"
    // >
      <div
        className="relative bg-white w-full max-w-4xl mx-4 rounded-2xl shadow-2xl p-6 overflow-y-auto max-h-[90vh] transform transition-all duration-300"
      >

        <h2 className="text-2xl font-semibold mb-6 text-gray-800">
          Profil Utilisateur
        </h2>

        {/* Statut de connexion */}
        <div
          className={`mb-4 p-4 rounded-lg ${
            isAuthenticated
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          <h5 className="font-semibold mb-1">Statut de connexion</h5>
          <p>
            {isAuthenticated
              ? "Utilisateur connecté"
              : "Utilisateur non connecté"}
          </p>
        </div>

        {/* Informations détaillées */}
        <div className="mb-4">
          <UserInfo showDetailed={true} />
        </div>

        {/* Rôles */}
        {client && (
          <div className="mb-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h5 className="font-semibold mb-3">Vérification des rôles</h5>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {["admin", "manager", "user"].map((role) => (
                <div
                  key={role}
                  className={`p-3 rounded-lg ${
                    hasRole(role)
                      ? "bg-green-100 text-green-800"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  <strong>
                    {role.charAt(0).toUpperCase() + role.slice(1)} :
                  </strong>{" "}
                  {hasRole(role) ? "Oui" : "Non"}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Session */}
        {client && (
          <div className="mb-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h5 className="font-semibold mb-3">Informations de session</h5>
            <p>
              <strong>Token présent :</strong> {getToken() ? "Oui" : "Non"}
            </p>
            {getToken() && (
              <p>
                <strong>Token (début) :</strong> {getToken().substring(0, 20)}
                ...
              </p>
            )}
            <p>
              <strong>Client en localStorage :</strong>{" "}
              {localStorage.getItem("client") ? "Oui" : "Non"}
            </p>
          </div>
        )}

        {/* Données brutes */}
        {client && (
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h5 className="font-semibold mb-3">Données brutes (Debug)</h5>
            <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
              {JSON.stringify(client, null, 2)}
            </pre>
          </div>
        )}

      </div>
    // </div>
  );
}
